import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, User } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const linkCls = (path) =>
    `text-sm tracking-wide transition-colors duration-200 hover:text-emerald-600 ${
      loc.pathname === path ? "text-emerald-600" : "text-slate-700"
    }`;

  return (
    <header className="sticky top-0 z-40 glass" data-testid="app-navbar">
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <div className="w-8 h-8 rounded-full bg-[#0A1128] flex items-center justify-center relative pulse-ring">
            <span className="text-[#D4AF37] font-serif text-lg leading-none">G</span>
          </div>
          <span className="font-serif text-xl tracking-tight text-[#0A1128]">Guest Smell</span>
          <sup className="text-[10px] text-slate-500">™</sup>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <Link to="/browse" className={linkCls("/browse")} data-testid="nav-browse">Browse Stays</Link>
          <Link to="/pricing" className={linkCls("/pricing")} data-testid="nav-pricing">Pricing</Link>
          <Link to="/about" className={linkCls("/about")} data-testid="nav-about">About</Link>
          {user && user.role === "guest" && (
            <Link to="/favorites" className={linkCls("/favorites")} data-testid="nav-favorites">Favorites</Link>
          )}
          {user && user.role === "host" && (
            <>
              <Link to="/host" className={linkCls("/host")} data-testid="nav-host">Host Dashboard</Link>
              <Link to="/host/schedule" className={linkCls("/host/schedule")} data-testid="nav-schedule">Schedule</Link>
            </>
          )}
          {user && user.role === "admin" && (
            <Link to="/admin" className={linkCls("/admin")} data-testid="nav-admin">Admin</Link>
          )}
          <Link to="/vision" className={linkCls("/vision")} data-testid="nav-vision">Vision</Link>
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <span className="hidden sm:flex items-center gap-2 text-sm text-slate-600" data-testid="nav-user">
                <User className="w-4 h-4" /> {user.name}
              </span>
              <Button
                variant="outline"
                size="sm"
                onClick={async () => { await logout(); nav("/"); }}
                data-testid="nav-logout"
                className="rounded-full"
              >
                <LogOut className="w-4 h-4 mr-1" /> Sign out
              </Button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login">
                <Button variant="ghost" size="sm" className="rounded-full">Sign in</Button>
              </Link>
              <Link to="/register" data-testid="nav-register">
                <Button size="sm" className="rounded-full bg-[#0A1128] hover:bg-[#1A2A3A] text-white">
                  Get Started
                </Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
